import { useQuery } from '@apollo/client/react';
import { BookingDetails, BookingUnavailable } from '@drycut/booking-components';
import { GetBookingDocument } from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

import BookingPubSubWrapper from '../BookingPubSubWrapper';

export function BookingDetailsByUid(): React.ReactElement {
  useDocumentTitle('DRYCUT - Booking details');

  const { uid } = useParams() as { uid: string };
  const { data, loading } = useQuery(GetBookingDocument, { variables: { uid } });

  if (loading) {
    return <Loader />;
  }

  if (!data?.booking) {
    return <BookingUnavailable />;
  }

  return (
    <BookingPubSubWrapper uid={uid}>
      <BookingDetails booking={data.booking} manual />
    </BookingPubSubWrapper>
  );
}
